import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { PriceAlertDetails, PriceAlertsOverview } from '../entities/price-alerts.entity';

@Injectable({ providedIn: 'root' })
export class AlertingInfrastructure {
  readonly #http = inject(HttpClient);

  readonly #endpoint = `${environment.apihost}/api/instrument/notification`;

  public getPriceAlertOverview(): Observable<PriceAlertsOverview[]> {
    return this.#http.get<PriceAlertsOverview[]>(this.#endpoint);
  }

  public getPriceAlertDetails(isin: string): Observable<PriceAlertDetails> {
    return this.#http.get<PriceAlertDetails>(`${this.#endpoint}/${isin}`);
  }

  public postPriceAlertDetails(priceAlertDetails: PriceAlertDetails): Observable<PriceAlertDetails> {
    return this.#http.post<PriceAlertDetails>(this.#endpoint, priceAlertDetails);
  }

  public deletePriceAlert(isin: string): Observable<PriceAlertDetails> {
    return this.#http.delete<PriceAlertDetails>(`${this.#endpoint}/${isin}`);
  }
}
